import React from 'react';
import { Link } from 'react-router';
import LazyLoad from 'react-lazyload';

class ImageDescCTA extends React.Component {
	handleClick() {
		global.dataLayer.push({
			event: 'Product Category Tile',
			eventCategory: 'Product Tiles',
			eventAction: global.location.pathname,
			eventLabel: `${this.props.title} - Model ${this.props.modelNumber}`
		});
	}

	render() {
		const { imgSrc, title, modelNumber } = this.props;
		const url = `product/${modelNumber}`;
		return (
			<li>
				<Link to={ url } onClick={ () => this.handleClick() }>
					<div className="product-img">
						<LazyLoad once={ true } offset={ 200 }>
							<img src={ imgSrc } alt="" />
						</LazyLoad>
					</div>
					<h3 className="product-title">{ title }</h3>
					<span className="product-model">
						Model { modelNumber }
					</span>
				</Link>
			</li>
		);
	};
}

export default ImageDescCTA;


// WEBPACK FOOTER //
// ./src/pages/common/ProductImageCTA.js